document.addEventListener("DOMContentLoaded", () => {
// Check if the current URL contains 'trade-in-program'
if (window.location.href.includes('trade-in-program')) {
  // Redirect to the new URL
  window.location.href = 'https://justgolfstuff.ca/apps/trade-in#/product-registration';
}
});

document.addEventListener("DOMContentLoaded", () => {
  $("#collection_carousel").owlCarousel({
    loop: true,
    margin: 20,
    slideTransition: "linear",
    autoplay: false,
    autoplayTimeout: 7000,
    responsiveClass: true,
    dots: true,
    nav: false,
    responsive: {
      0: {
        items: 2,
      },
      600: {
        items: 2,
      },
      1000: {
        items: 3,
      },
      1200: {
        items: 4,
      },
    },
  });
});
document.addEventListener("DOMContentLoaded", () => {
  $("#sub_collection_carousel").owlCarousel({
    loop: false,
    margin: 40,
    slideTransition: "linear",
    autoplay: true,
    autoplayTimeout: 5000,
    dots: true,
    nav: false,
    responsiveClass: true,
    responsive: {
      0: {
        items: 2,
      },
      600: {
        items: 4,
      },
      1000: {
        items: 5,
      },
      1200: {
        items: 6,
      },
    },
  });
});

document.addEventListener("DOMContentLoaded", () => {  

document.querySelector('.slp_fcec57').addEventListener('click', function () {
  // Replace the URL below with the page you want to open
  window.open('https://justgolfstuff.ca/pages/jgs-rewards', '_blank');
});
  
});
